module.exports = __webpack_public_path__ + "img/128.5bd23d74.jpg";